/**
 * Shared country list, flag helper, and chart colour palette.
 * Used by GeoTrustDashboard and DashboardCountryVaults.
 */

export const COUNTRY_LIST: { iso2: string; name: string }[] = [
  {iso2:'AD',name:'Andorra'},{iso2:'AE',name:'United Arab Emirates'},{iso2:'AF',name:'Afghanistan'},
  {iso2:'AG',name:'Antigua & Barbuda'},{iso2:'AL',name:'Albania'},{iso2:'AM',name:'Armenia'},
  {iso2:'AO',name:'Angola'},{iso2:'AR',name:'Argentina'},{iso2:'AT',name:'Austria'},
  {iso2:'AU',name:'Australia'},{iso2:'AZ',name:'Azerbaijan'},{iso2:'BA',name:'Bosnia & Herzegovina'},
  {iso2:'BB',name:'Barbados'},{iso2:'BD',name:'Bangladesh'},{iso2:'BE',name:'Belgium'},
  {iso2:'BF',name:'Burkina Faso'},{iso2:'BG',name:'Bulgaria'},{iso2:'BH',name:'Bahrain'},
  {iso2:'BI',name:'Burundi'},{iso2:'BJ',name:'Benin'},{iso2:'BN',name:'Brunei'},
  {iso2:'BO',name:'Bolivia'},{iso2:'BR',name:'Brazil'},{iso2:'BS',name:'Bahamas'},
  {iso2:'BT',name:'Bhutan'},{iso2:'BW',name:'Botswana'},{iso2:'BY',name:'Belarus'},
  {iso2:'BZ',name:'Belize'},{iso2:'CA',name:'Canada'},{iso2:'CD',name:'DR Congo'},
  {iso2:'CF',name:'Central African Republic'},{iso2:'CG',name:'Republic of Congo'},
  {iso2:'CH',name:'Switzerland'},{iso2:'CI',name:"Côte d'Ivoire"},{iso2:'CL',name:'Chile'},
  {iso2:'CM',name:'Cameroon'},{iso2:'CN',name:'China'},{iso2:'CO',name:'Colombia'},
  {iso2:'CR',name:'Costa Rica'},{iso2:'CU',name:'Cuba'},{iso2:'CV',name:'Cape Verde'},
  {iso2:'CY',name:'Cyprus'},{iso2:'CZ',name:'Czech Republic'},{iso2:'DE',name:'Germany'},
  {iso2:'DJ',name:'Djibouti'},{iso2:'DK',name:'Denmark'},{iso2:'DM',name:'Dominica'},
  {iso2:'DO',name:'Dominican Republic'},{iso2:'DZ',name:'Algeria'},{iso2:'EC',name:'Ecuador'},
  {iso2:'EE',name:'Estonia'},{iso2:'EG',name:'Egypt'},{iso2:'ES',name:'Spain'},
  {iso2:'ET',name:'Ethiopia'},{iso2:'FI',name:'Finland'},{iso2:'FJ',name:'Fiji'},
  {iso2:'FR',name:'France'},{iso2:'GA',name:'Gabon'},{iso2:'GB',name:'United Kingdom'},
  {iso2:'GD',name:'Grenada'},{iso2:'GE',name:'Georgia'},{iso2:'GH',name:'Ghana'},
  {iso2:'GM',name:'Gambia'},{iso2:'GN',name:'Guinea'},{iso2:'GQ',name:'Equatorial Guinea'},
  {iso2:'GR',name:'Greece'},{iso2:'GT',name:'Guatemala'},{iso2:'GW',name:'Guinea-Bissau'},
  {iso2:'GY',name:'Guyana'},{iso2:'HN',name:'Honduras'},{iso2:'HR',name:'Croatia'},
  {iso2:'HT',name:'Haiti'},{iso2:'HU',name:'Hungary'},{iso2:'ID',name:'Indonesia'},
  {iso2:'IE',name:'Ireland'},{iso2:'IL',name:'Israel'},{iso2:'IN',name:'India'},
  {iso2:'IQ',name:'Iraq'},{iso2:'IR',name:'Iran'},{iso2:'IS',name:'Iceland'},
  {iso2:'IT',name:'Italy'},{iso2:'JM',name:'Jamaica'},{iso2:'JO',name:'Jordan'},
  {iso2:'JP',name:'Japan'},{iso2:'KE',name:'Kenya'},{iso2:'KG',name:'Kyrgyzstan'},
  {iso2:'KH',name:'Cambodia'},{iso2:'KM',name:'Comoros'},{iso2:'KP',name:'North Korea'},
  {iso2:'KR',name:'South Korea'},{iso2:'KW',name:'Kuwait'},{iso2:'KZ',name:'Kazakhstan'},
  {iso2:'LA',name:'Laos'},{iso2:'LB',name:'Lebanon'},{iso2:'LC',name:'Saint Lucia'},
  {iso2:'LI',name:'Liechtenstein'},{iso2:'LK',name:'Sri Lanka'},{iso2:'LR',name:'Liberia'},
  {iso2:'LS',name:'Lesotho'},{iso2:'LT',name:'Lithuania'},{iso2:'LU',name:'Luxembourg'},
  {iso2:'LV',name:'Latvia'},{iso2:'LY',name:'Libya'},{iso2:'MA',name:'Morocco'},
  {iso2:'MC',name:'Monaco'},{iso2:'MD',name:'Moldova'},{iso2:'ME',name:'Montenegro'},
  {iso2:'MG',name:'Madagascar'},{iso2:'MK',name:'North Macedonia'},{iso2:'ML',name:'Mali'},
  {iso2:'MM',name:'Myanmar'},{iso2:'MN',name:'Mongolia'},{iso2:'MR',name:'Mauritania'},
  {iso2:'MT',name:'Malta'},{iso2:'MU',name:'Mauritius'},{iso2:'MV',name:'Maldives'},
  {iso2:'MW',name:'Malawi'},{iso2:'MX',name:'Mexico'},{iso2:'MY',name:'Malaysia'},
  {iso2:'MZ',name:'Mozambique'},{iso2:'NA',name:'Namibia'},{iso2:'NE',name:'Niger'},
  {iso2:'NG',name:'Nigeria'},{iso2:'NI',name:'Nicaragua'},{iso2:'NL',name:'Netherlands'},
  {iso2:'NO',name:'Norway'},{iso2:'NP',name:'Nepal'},{iso2:'NZ',name:'New Zealand'},
  {iso2:'OM',name:'Oman'},{iso2:'PA',name:'Panama'},{iso2:'PE',name:'Peru'},
  {iso2:'PG',name:'Papua New Guinea'},{iso2:'PH',name:'Philippines'},{iso2:'PK',name:'Pakistan'},
  {iso2:'PL',name:'Poland'},{iso2:'PT',name:'Portugal'},{iso2:'PY',name:'Paraguay'},
  {iso2:'QA',name:'Qatar'},{iso2:'RO',name:'Romania'},{iso2:'RS',name:'Serbia'},
  {iso2:'RU',name:'Russia'},{iso2:'RW',name:'Rwanda'},{iso2:'SA',name:'Saudi Arabia'},
  {iso2:'SB',name:'Solomon Islands'},{iso2:'SC',name:'Seychelles'},{iso2:'SD',name:'Sudan'},
  {iso2:'SE',name:'Sweden'},{iso2:'SG',name:'Singapore'},{iso2:'SI',name:'Slovenia'},
  {iso2:'SK',name:'Slovakia'},{iso2:'SL',name:'Sierra Leone'},{iso2:'SM',name:'San Marino'},
  {iso2:'SN',name:'Senegal'},{iso2:'SO',name:'Somalia'},{iso2:'SR',name:'Suriname'},
  {iso2:'SS',name:'South Sudan'},{iso2:'ST',name:"São Tomé & Príncipe"},
  {iso2:'SV',name:'El Salvador'},{iso2:'SY',name:'Syria'},{iso2:'SZ',name:'Eswatini'},
  {iso2:'TD',name:'Chad'},{iso2:'TG',name:'Togo'},{iso2:'TH',name:'Thailand'},
  {iso2:'TJ',name:'Tajikistan'},{iso2:'TL',name:'Timor-Leste'},{iso2:'TM',name:'Turkmenistan'},
  {iso2:'TN',name:'Tunisia'},{iso2:'TO',name:'Tonga'},{iso2:'TR',name:'Turkey'},
  {iso2:'TT',name:'Trinidad & Tobago'},{iso2:'TV',name:'Tuvalu'},{iso2:'TZ',name:'Tanzania'},
  {iso2:'UA',name:'Ukraine'},{iso2:'UG',name:'Uganda'},{iso2:'US',name:'United States'},
  {iso2:'UY',name:'Uruguay'},{iso2:'UZ',name:'Uzbekistan'},{iso2:'VA',name:'Vatican City'},
  {iso2:'VC',name:'St Vincent & Grenadines'},{iso2:'VE',name:'Venezuela'},{iso2:'VN',name:'Vietnam'},
  {iso2:'VU',name:'Vanuatu'},{iso2:'WS',name:'Samoa'},{iso2:'YE',name:'Yemen'},
  {iso2:'ZA',name:'South Africa'},{iso2:'ZM',name:'Zambia'},{iso2:'ZW',name:'Zimbabwe'},
];

/** Convert an ISO-2 code to its regional indicator flag emoji */
export const countryFlag = (iso2: string): string =>
  iso2.toUpperCase().replace(/./g, c => String.fromCodePoint(c.charCodeAt(0) + 127397));

export const PIE_COLORS = ['#0ea5e9', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899'];
